const KEY = 'reportReturn';

export const rememberReportOrigin = (reportPath) => {
    const { pathname, search } = window.location;

    sessionStorage.setItem(
        KEY,
        JSON.stringify({ reportPath, originUrl: pathname + search })
    );
};

export const reportOriginUrl = (reportPath) => {
    const stored = JSON.parse(sessionStorage.getItem(KEY) || 'null');

    return stored?.reportPath === reportPath ? stored.originUrl : null;
};
